import { socialLinks } from "../User";
import { Icon } from "@iconify/react";

const Social = () => {
    const socialIcons = socialLinks.map((socialLink, index) => {
        const isCodeforces = socialLink.icon === "simple-icons:codeforces";
        return (
            <a
                key={index}
                href={socialLink.link}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-lg hover:text-primaryColor hover:-translate-x-1 transition transform duration-300 ease-in-out"
            >
                <div
                    data-aos="fade-up-left"
                    data-aos-duration="800"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transform: isCodeforces ? 'rotate(180deg)' : 'rotate(180deg)',
                    }}
                >
                    {isCodeforces ? (
                        <Icon icon={socialLink.icon as string} style={{ fontSize: "30px", transform: 'rotate(90deg)' }} />
                    ) : (
                        <socialLink.icon stroke={1.5} size={30} style={{ transform: 'rotate(90deg)' }} />
                    )}
                </div>
            </a>
        );
    });

    return (
        <div  className="flex md-mx:hidden text-textColor items-center gap-8 fixed bottom-32 -left-48 rotate-90" >
            {socialIcons}
            <hr className="border w-40 rounded-full bg-textColor border-textColor"  data-aos="fade-up-left" data-aos-duration="800"/>
        </div>
    );
};

export default Social;
